export default {
    failedToRemoveProductsDueToLoadedContainer: "无法删除 {{no}} 产品已上货柜",
    atLeast1ProductIsRequired: "至少需要1个商品",
    added1NewProductEntry: '添加了 (1) 条新产品条目',
    selected1Item: '已选择 (1) 个',
    added1NewItemEntry: '添加了 (1) 个新货物条目',
    thereAreSomeProductsAlreadyLoadedToTheContainers: '一些产品已经装载到货柜中了',
    itemsAtLeastHave1Row: '至少需要 (1) 行唛头',
    pleaseSelectAllTheShippingRatesToProceed: '请选定所有运费率得以继续',
    mustSelectAtLeast1Selection: '必须选择至少一个选项',
    pleaseSelectContainer: '请选择货柜！',
    thereIsNotItemsRelatedToThisContainer: '该货柜没有相关物品',
    supplierOrContainerAreNotYetSelectedPleaseSelectBothForNextStep: '供应商或货柜尚未选择。请同时选择两者以进行下一步!',
    youHaveToSelectTheFullQtyIfThereIsNotSplitOption: '如没有分批选项，您必须选择全部数量',
    youHaveToSelectTheQtyAtLeastMoreThan1Qty: '必须选择至少大于1的数量',
    selectedProductHasNotSyncToHQYet: '所选商品尚未同步到总部',
    onlySelect1ProductToProceed: '仅选择一个商品',
    selectedProductHasBeenLoadedToContainer: '所选的商品已上柜',
    selectedProductQtyHasChanged: '所选商品数量已变更，请刷新后重试',
    pleaseSelectAtLeast1DataFilter: '至少选择一个数据筛选',
    savedSuccess: '保存成功',
    productAddedToContainer: '货柜添加成功',
    removeFromContainerSuccess: '选择货物已取消装柜',
    productsSuccessDeleted: '选择货物已删除'

}